import { useSearchParams } from 'react-router-dom';
import buildPeriodFromMonth from './buildPeriodFromMonth';
import resolveMonthParam from './resolveMonthParam';
import type { UseSelectedCostMonthResult } from '../types';

const useSelectedCostMonth = (): UseSelectedCostMonthResult => {
    const [searchParams, setSearchParams] = useSearchParams();
    const now = new Date();
    const month = resolveMonthParam({
        monthParam: searchParams.get('month'),
        now,
    });
    const period = buildPeriodFromMonth({ month, now });

    const setMonth = ({ month: nextMonth }: { month: string }) => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set('month', nextMonth);
        setSearchParams(nextParams);
    };

    return { month, period, setMonth };
};

export default useSelectedCostMonth;
